import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

const data = [
  { mes: 'Jan', planejado: 5, realizado: 4 },
  { mes: 'Fev', planejado: 12, realizado: 10 },
  { mes: 'Mar', planejado: 22, realizado: 18 },
  { mes: 'Abr', planejado: 35, realizado: 28 },
  { mes: 'Mai', planejado: 48, realizado: 42 },
  { mes: 'Jun', planejado: 60, realizado: 55 },
  { mes: 'Jul', planejado: 72, realizado: 64 },
  { mes: 'Ago', planejado: 82, realizado: 73 },
  { mes: 'Set', planejado: 90, realizado: 80 },
  { mes: 'Out', planejado: 95, realizado: 87 },
  { mes: 'Nov', planejado: 98, realizado: 92 },
  { mes: 'Dez', planejado: 100, realizado: 96 },
];

const CurvaSChart: React.FC = () => (
  <div className="w-full h-[200px]">
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data} margin={{ top: 10, right: 10, left: -15, bottom: 0 }}>
        <defs>
          <linearGradient id="planejadoGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="hsl(168, 56%, 42%)" stopOpacity={0.3} />
            <stop offset="95%" stopColor="hsl(168, 56%, 42%)" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="realizadoGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="hsl(168, 56%, 50%)" stopOpacity={0.3} />
            <stop offset="95%" stopColor="hsl(168, 56%, 50%)" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="hsl(220, 15%, 88%)" />
        <XAxis dataKey="mes" tick={{ fontSize: 12, fill: 'hsl(var(--muted-foreground))' }} tickLine={false} axisLine={false} />
        <YAxis tick={{ fontSize: 12, fill: 'hsl(var(--muted-foreground))' }} tickLine={false} axisLine={false} unit="%" />
        <Tooltip
          contentStyle={{ backgroundColor: 'hsl(var(--card))', border: '1px solid hsl(var(--border))', borderRadius: '8px', fontSize: '12px' }}
          formatter={(v: number, name: string) => [`${v}%`, name === 'planejado' ? 'Planejado' : 'Realizado']}
        />
        <Area type="monotone" dataKey="planejado" stroke="hsl(168, 56%, 42%)" fill="url(#planejadoGrad)" strokeWidth={2} strokeDasharray="6 3" />
        <Area type="monotone" dataKey="realizado" stroke="hsl(168, 56%, 50%)" fill="url(#realizadoGrad)" strokeWidth={2} />
      </AreaChart>
    </ResponsiveContainer>
    <div className="flex justify-center gap-4 mt-1 text-xs text-muted-foreground">
      <span className="flex items-center gap-1"><span className="w-4 h-0.5 inline-block" style={{ borderTop: '2px dashed hsl(168, 56%, 42%)' }} /> Planejado</span>
      <span className="flex items-center gap-1"><span className="w-4 h-0.5 bg-success inline-block" /> Realizado</span>
    </div>
  </div>
);

export default CurvaSChart;
